import React from 'react';
import {
  TypeImplementation,
  Expressions,
  matchExpression,
  Plugins,
  Component,
  ExpressionPath,
} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  extendExpressionEditorActionAtPath,
} from '@packages/systems/ExpressionEditor-utils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {reportBug} from '@packages/utilities/reporter';
import type {Expression} from '@packages/systems/wfdl-ast';
import {namesEqual, qualify} from '@packages/systems/wfdl-Qualified';
import {constantFalse} from '@packages/utilities/fp/utils';

import {
  ContextualExpressions,
  stripAll,
} from '@packages/utilities/contextual-expression';

const {getIn} = ContextualExpressions;

export const findCheckboxInputPath = (expr: Expression) =>
  Expressions.findPaths(
    expr,
    matchExpression({
      Element: (el) =>
        namesEqual(
          el.type,
          qualify(Plugins.name('Form'), Component.name('FormCheckboxInput'))
        ) ||
        namesEqual(
          el.type,
          qualify(
            Plugins.name('Users'),
            Component.name('UserFormCheckboxInput')
          )
        ),
      _: constantFalse,
    })
  )[0];

const CheckboxChildrenType = TypeImplementation.Alias({
  type: TListOfElement,
  render: function RenderCheckboxChildren({expr, dispatch}) {
    const strippedExpr = stripAll(expr);
    const checkboxInputPath = findCheckboxInputPath(strippedExpr);

    if (!checkboxInputPath) {
      reportBug(
        'FormCheckboxInputNotFoundInFormCheckboxWrapper',
        'Form Checkbox Input has not been found in Form Checkbox Wrapper',
        {
          expr: strippedExpr,
          team: 'platform',
          ticket: 'https://webflow.atlassian.net/browse/PLAT-1058',
        }
      );
      return null;
    }

    const path = [
      ...checkboxInputPath,
      {in: 'Element'},
    ] satisfies ExpressionPath;

    const checkboxInputData = getIn(expr, path);
    if (!checkboxInputData) return null;
    const onCheckboxInputDataChange =
      extendExpressionEditorActionAtPath(dispatch)(path);

    return (
      <ExpressionEditor
        expression={checkboxInputData}
        dispatch={onCheckboxInputDataChange}
      />
    );
  },
});

export default CheckboxChildrenType;
